// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"e42dd1a4","186":"333e9450","193":"27930653","403":"5561310e"}[chunkId] + ".chunk.js";
};